import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useState } from 'react';
import { CheckCircleTwoTone, LockOutlined, WarningTwoTone } from '@ant-design/icons';
import { Button, Form, Input, Spin } from 'antd';
import axios from 'axios';
import { axiosErrorHandler } from '../../swzutils';
import LinkHeader from "http-link-header";
import { useParams } from "react-router-dom";
import PublicPageLayout from "../PublicPageLayout";
const PasswordResetForm = (props) => {
    const [posting, setPosting] = useState(false);
    const [mode, setMode] = useState('INITIAL_FORM');
    const [nextLink, setNextLink] = useState(null);
    const formRef = useRef(null);
    const onFinish = (formValues) => {
        postPasswordReset(formValues);
    };
    const handleConfirmPassword = (rule, value) => {
        let newPassword = formRef.current.getFieldValue('newPassword');
        if (value && value !== newPassword) {
            return Promise.reject("Confirmation password does not match new password.");
        }
        return Promise.resolve();
    };
    const postPasswordReset = (values) => {
        setPosting(true);
        axios.post('/admin/v1/authentication/password-reset', {
            token: props.token,
            password: values.newPassword
        }).then((response) => {
            if (response.headers && response.headers['link']) {
                const links = LinkHeader.parse(response.headers['link']);
                if (links && links.has('rel', 'next')) {
                    const nextLinkURI = links.get('rel', 'next')[0].uri;
                    setNextLink(nextLinkURI);
                }
            }
            switch (response.data.userType) {
                case "DRIVER":
                    setMode('DRIVER_PASSWORD_RESET_SUCCESS');
                    break;
                case "CUSTOMER":
                    setMode('CUSTOMER_PASSWORD_RESET_SUCCESS');
                    break;
                default:
                    setMode('ADMIN_USER_PASSWORD_RESET_SUCCESS');
                    break;
            }
        }).catch((error) => {
            if (error.response && error.response.status === 404) {
                setMode('INVALID_OR_EXPIRED_CODE');
            }
            else {
                axiosErrorHandler(error);
            }
        }).finally(() => {
            setPosting(false);
        });
    };
    return (_jsxs(Spin, { spinning: posting, delay: 500, children: [mode === 'DRIVER_PASSWORD_RESET_SUCCESS' &&
                _jsxs("div", { children: [_jsx("p", { className: "text-center", children: _jsx(CheckCircleTwoTone, { style: { fontSize: '100px' }, twoToneColor: "#52c41a" }) }), _jsx("p", { className: "text-center", children: "Your password has been successfully reset.  You can now use your new password to login to the driver app." })] }), mode === 'CUSTOMER_PASSWORD_RESET_SUCCESS' &&
                _jsxs("div", { children: [_jsx("p", { className: "text-center", children: _jsx(CheckCircleTwoTone, { style: { fontSize: '100px' }, twoToneColor: "#52c41a" }) }), _jsx("p", { className: "text-center", children: "Your password has been successfully reset." }), _jsx("p", { className: "text-center", children: _jsx("a", { href: nextLink ?? '', className: "ant-btn ant-btn-primary ant-btn-lg", children: "Login Now!" }) })] }), mode === 'ADMIN_USER_PASSWORD_RESET_SUCCESS' &&
                _jsxs("div", { children: [_jsx("p", { className: "text-center", children: _jsx(CheckCircleTwoTone, { style: { fontSize: '100px' }, twoToneColor: "#52c41a" }) }), _jsx("p", { className: "text-center", children: "Your password has been successfully reset." }), _jsx("p", { className: "text-center", children: _jsx("a", { href: "/#/login", className: "ant-btn ant-btn-primary ant-btn-lg", children: "Login Now!" }) })] }), mode === 'INVALID_OR_EXPIRED_CODE' &&
                _jsxs("div", { children: [_jsx("p", { className: "text-center", children: _jsx(WarningTwoTone, { style: { fontSize: '100px' }, twoToneColor: "#FFCC00" }) }), _jsx("p", { className: "text-center", children: "The link you used has expired. For security reasons password reset links are only valid for 12 hours.  Please use the forgot password feature to request a new link that will be active for another 12 hours." }), _jsx("p", { className: "text-center", children: _jsx("a", { href: "#/forgot-password", className: "ant-btn ant-btn-primary ant-btn-lg", children: "Forgot Password" }) })] }), mode === 'INITIAL_FORM' &&
                _jsxs(Form, { layout: "vertical", onFinish: onFinish, ref: formRef, children: [_jsx(Form.Item, { name: "newPassword", label: "Create Password", rules: [
                                { required: true, message: 'Please input a new password.' },
                                { max: 20, message: 'Please limit your password to 20 characters.' },
                                { pattern: /^(?=.*[0-9])(?=.{10,})/, message: 'Must be at least 10 (max 20) characters and contain a digit' }
                            ], children: _jsx(Input.Password, { type: "password", maxLength: 20, placeholder: "New Password" }) }), _jsx(Form.Item, { name: "confirmPassword", label: "Confirm Password", rules: [
                                { required: true, message: 'Please re-enter your new password.' },
                                { max: 50, message: 'Please limit your password to 50 characters.' },
                                { validator: handleConfirmPassword }
                            ], children: _jsx(Input.Password, { type: "password", maxLength: 50, placeholder: "Confirm Password" }) }), _jsx("div", { className: "divider", children: "\u00A0" }), _jsx("div", { className: "text-right", children: _jsxs(Button, { type: "primary", size: "large", htmlType: "submit", children: [_jsx(LockOutlined, {}), "\u00A0 Save"] }) })] })] }));
};
const PasswordResetPage = () => {
    const params = useParams();
    return (_jsx(PublicPageLayout, { heading: "Choose a Password", children: _jsx(PasswordResetForm, { token: params.token }) }));
};
export default PasswordResetPage;
